// EmptyState — centered "no results" panel.
//
// Two visual variants:
//   'card' (default) — surface bg + border, used when the empty state
//                      replaces a card / list area.
//   'bare'           — no chrome, just centered text. Used inside an
//                      area that already has its own card frame, or as
//                      a global "no posts" message.
//
// Always pass `theme`. `label` is the headline; `hint` is an optional
// dimmer second line.

import type { ThemeTokens } from '@nayto/theme';

interface EmptyStateProps {
  theme: ThemeTokens;
  label: string;
  hint?: string;
  variant?: 'card' | 'bare';
}

export function EmptyState({
  theme,
  label,
  hint,
  variant = 'card',
}: EmptyStateProps) {
  if (variant === 'bare') {
    return (
      <div
        style={{
          padding: '48px 16px',
          textAlign: 'center',
          color: theme.textMuted,
          fontSize: 14,
        }}
      >
        <div style={{ fontWeight: 600, color: theme.text, marginBottom: hint ? 4 : 0 }}>
          {label}
        </div>
        {hint && <div style={{ fontSize: 12 }}>{hint}</div>}
      </div>
    );
  }
  return (
    <div
      style={{
        padding: '28px 14px',
        textAlign: 'center',
        background: theme.surface,
        border: `1px solid ${theme.border}`,
        borderRadius: 14,
        marginBottom: 14,
      }}
    >
      <div
        style={{
          fontSize: 14,
          fontWeight: 600,
          color: theme.text,
          marginBottom: hint ? 4 : 0,
        }}
      >
        {label}
      </div>
      {hint && <div style={{ fontSize: 12, color: theme.textMuted }}>{hint}</div>}
    </div>
  );
}
